export default "__VITE_ASSET__1HuEDD8Z__"